import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerGlobalConfirmDeleteDialogProviderProviderResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    modal: {
      GlobalConfirmDeleteDialogProvider: {
        cancel: 'Abbrechen',
        delete: 'Löschen',
        message: 'Wollen Sie "{{ name }}" wirklich löschen?',
        title: 'Wirklich löschen?'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}